import { t, type MessageKey } from "../i18n";

/** A template's status chip colour, the same in Settings › Modelos and in the send picker. */
export const templateChip = (status: string) =>
  status === "approved"
    ? "success"
    : status === "rejected" || status === "paused" || status === "disabled"
      ? "failed"
      : status === "draft"
        ? "closed"
        : "waiting_internal";

export const templateStatusLabel = (status: string) =>
  t(`templates.status.${status}` as MessageKey);

interface Listed {
  account_id: string;
  status: string;
  name: string;
  components: unknown[];
}

/** The template's body text, as the picker shows it under the name. */
export const templateBody = (x: { components: unknown[] }) =>
  (x.components as Array<{ type: string; text?: string }>).find(
    (c) => c.type.toUpperCase() === "BODY",
  )?.text ?? "";

/**
 * What the send picker lists: the templates of the number's WhatsApp account (a template goes
 * out only through its account) that match the search. The approved ones are to choose; the ones
 * Meta is reviewing or has paused are shown switched off, so nobody wonders where they went.
 */
export function pickerTemplates<T extends Listed>(
  all: T[],
  accountId: string | null | undefined,
  query: string,
): { approved: T[]; waiting: T[] } {
  const q = query.trim().toLowerCase();
  const listed = all.filter(
    (x) =>
      (!accountId || x.account_id === accountId) &&
      (!q ||
        x.name.toLowerCase().includes(q) ||
        templateBody(x).toLowerCase().includes(q)),
  );
  return {
    approved: listed.filter((x) => x.status === "approved"),
    waiting: listed.filter(
      (x) => x.status === "pending" || x.status === "paused",
    ),
  };
}
